import { render, staticRenderFns } from "./NotificationTrigger.vue?vue&type=template&id=3b8172b9&scoped=true&"
import script from "./NotificationTrigger.vue?vue&type=script&lang=ts&"
export * from "./NotificationTrigger.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationTrigger.vue?vue&type=style&index=0&id=3b8172b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8172b9",
  null
  
)

export default component.exports